<template>

  <div class="full-width">

    <!-- //TITLE MOBILE -->
    <div class="header mobile">
      <h1>{{general.exportTitle}}</h1>
      <b-button class="bt-challenges mb-3" @click="create()"  ref="btnShowMobile" >{{general.formBtExportCreate}}</b-button>
    </div>
    <div class="mobile px-4">
      <a v-if="downloadDicoLink" :href="downloadDicoLink" target="_blank" class="bt text-primary text-bold d-flex justify-content-end">
        Télécharger le dictionnaire de données  <i class="ml-3 fas fa-download"></i>
      </a>
    </div>
    <!-- //TITLE MOBILE -->

    <!-- CONTENT -->
    <div class="block__sidebar content__exports">

      <!-- //TITLE DESKTOP -->
      <div class="header desktop">
        <h1>{{general.exportTitle}}</h1>
        <div class="text-right">
          <div class="d-flex align-items-baseline justify-content-between">
            <h4 class="blue cursor-pointer mr-4" @click="showNotice()"><i class="fas fa-file-alt mr-2"></i> Notice</h4>
            <b-button class="bt-challenges mb-3" @click="create()">{{general.formBtExportCreate}}</b-button>
          </div>
          <a v-if="downloadDicoLink" :href="downloadDicoLink" target="_blank" class="bt text-primary text-bold d-flex justify-content-end">
            Télécharger le dictionnaire de données  <i class="ml-3 fas fa-download"></i>
          </a>
        </div>
      </div>
      <!-- //TITLE DESKTOP -->

      <div class="waiting-export d-flex align-items-baseline justify-content-between" v-if="seeInfos || seeInfosForAdminExports">
        <p>Vous avez des exports en cours, les résultats peuvent mettre 1 à 2 minutes pour être disponible.</p>
        <b-button
            @click="load()"
            class="btn-challenges btn-export form-group m-0"
            :class="{disabled:isLoading}"
        >
          <i class="fas fa-sync-alt"></i>
        </b-button>
      </div>

      <div class="d-flex block__cardSimple w-100 justify-content-center" v-if="haveAccess(ApplicationsAccessEnum.APP_ADMIN_EXPORT)">
        <div class="card card-simple w-100">
          <div class="d-flex justify-content-between align-items-center pr-4">
            <h2 class="blue">Exports admin</h2>
          </div>

          <div class="pl-4 pb-4" v-if="(adminExports === null || adminExports.length === 0) && !isLoading">
            <div class="date">Aucun export admin disponible </div>
          </div>

          <PuSkeleton :loading="isLoadingAdminExports" class="m-3" :count="1">
            <div v-if="isLoadingAdminExports"></div>
          </PuSkeleton>

          <div class="pl-4 pr-4">
            <ul class="p-0" v-if="adminExports && adminExports.length > 0">
              <li class="pl-0 pr-0 pt-2 pb-3 mt-2 mb-2 card-body d-flex justify-content-between border-bottom grey" >
                <div class="col-3 p-0 text-truncate">
                  Nom
                </div>

                <div class="col-2 p-0">
                  Date du fichier
                </div>

                <div class="col-2 p-0">
                  Statut
                </div>

                <div class="col-2 p-0">
                  Action
                </div>
              </li>
              <li class="pl-0 pr-0 pt-2 pb-3 mt-2 mb-2  p-0 card-body d-flex justify-content-between align-items-center border-bottom" v-for="(item, key) in adminExports" :key="key">
                <div class="col-3 p-0 text-truncate">
                  {{ item.name }}
                </div>

                <div class="col-2 p-0">
                  {{ getReadableDate(item.monitoring.date) }}
                </div>

                <div class="col-2 p-0">
                  <Pill :text="getReadableStatus(item.status)" :status="item.status"></Pill>
                </div>

                <div class="col-2 p-0 d-flex justify-content-between align-items-center">
                  <Action @click.native="item.status !== 'completed' ? null : download(item)" :disabled="item.status !== 'completed'" :icon="'far fa-file-export'" :margin-left="'5px'"></Action>
                  <Action @click.native="see(item)" :icon="'far fa-eye'"></Action>
                </div>

              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="d-flex block__cardSimple w-100 justify-content-center" v-if="haveAccess(ApplicationsAccessEnum.APP_EXPORT)">
        <div class="card card-simple w-100">
          <div class="d-flex justify-content-between align-items-center pr-4">
            <h2 class="blue">{{general.exportSubtitle}}</h2>
          </div>

          <div class="pl-4 pb-4" v-if="(exports === null || exports.length === 0) && !isLoading">
            <div class="date">Aucun export disponible ... </div>
          </div>

          <PuSkeleton :loading="isLoading" class="m-3" :count="1">
            <div v-if="isLoading"></div>
          </PuSkeleton>

          <div class="pl-4 pr-4">
            <ul class="p-0" v-if="exports && exports.length > 0">
              <li class="pl-0 pr-0 pt-2 pb-3 mt-2 mb-2 card-body d-flex justify-content-between border-bottom grey" >
                <div class="col-1 p-0">
                  Favoris
                </div>

                <div class="col-3 p-0 text-truncate">
                  Nom
                </div>

                <div class="col-2 p-0">
                  Date de création
                </div>

                <div class="col-2 p-0">
                  Date du fichier
                </div>

                <div class="col-2 p-0">
                  Statut
                </div>

                <div class="col-2 p-0">
                  Action
                </div>
              </li>
              <li class="pl-0 pr-0 pt-2 pb-3 mt-2 mb-2  p-0 card-body d-flex justify-content-between align-items-center border-bottom" v-for="(item, key) in exports" :key="key">
                <div @click="favorite(item)" class="col-1 p-0 clickable">
                  <i :class="getFavoriteIcon(item).class" :style="{ 'color' : getFavoriteIcon(item).color }"></i>
                </div>

                <div class="col-3 p-0 text-truncate">
                  {{ item.name }}
                </div>

                <div class="col-2 p-0">
                  {{ getReadableDate(item.createdAt) }}
                </div>

                <div class="col-2 p-0">
                  {{ getReadableDate(item.monitoring.date) }}
                </div>

                <div class="col-2 p-0">
                  <Pill :text="getReadableStatus(item.status)" :status="item.status"></Pill>
                </div>

                <div class="col-2 p-0 d-flex justify-content-between align-items-center">
                  <Action @click.native="duplicate(item)" :icon="'fal fa-copy'"></Action>
                  <Action @click.native="item.status !== 'completed' ? null : download(item)" :disabled="item.status !== 'completed'" :icon="'far fa-file-export'" :margin-left="'5px'"></Action>
                  <Action @click.native="see(item)" :icon="'far fa-eye'"></Action>
                  <Action @click.native="remove(item)" :icon="'far fa-trash'" :mode="'danger'"></Action>
                </div>

              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- CONTENT -->

    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
    <transition name="slide">
      <keep-alive>
        <router-view class="transition"></router-view>
      </keep-alive>
    </transition>
    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->

    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
    <transition name="modal">
      <keep-alive>
        <router-view name="helper" class="myModal"></router-view>
      </keep-alive>
    </transition>
    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->

    <form-export></form-export>
    <notice-modal></notice-modal>
  </div>

</template>


<script>
import { mapGetters } from 'vuex'
import ApiService from '../../../../services/ApiService'
import ApiAuthenticationService from '../../../../services/ApiAuthenticationService'
import Pill from "@/components/module/pill/Pill.vue";
import Action from "@/components/module/action/Action.vue";
import FormExport from "@/components/module/modal/FormExport.vue";
import NoticeModal from "@/components/module/modal/NoticeModal.vue";
import {ApplicationsAccessEnum} from "@/services/Enum/ApplicationsAccessEnum";


export default {
  name:"exportsHome",
  components:{
    FormExport,
    NoticeModal,
    Action,
    Pill,
  },
  mixins: [
  ],
  computed: {
    ApplicationsAccessEnum() {
      return ApplicationsAccessEnum
    },
    ...mapGetters([
      'getBrowse',
      'getGeneral',
      'getExportUpdated'
    ])
  },
  data () {
    return {
      content:"",
      formContent:"",
      general:'',
      isMobile:false,
      isLoading: false,
      isLoadingAdminExports: false,
      seeInfos: false,
      seeInfosForAdminExports: false,
      exports: null,
      adminExports: null,
      interval: 0,
      downloadDicoLink: null,
      currentUser: null,
    }
  },
  created (){
    this.general = this.getGeneral;
    this.currentType = ApiAuthenticationService.getCurrentUser().type;
    this.currentUser = ApiAuthenticationService.getCurrentUser();
    this.getData().then();
  },
  mounted() {
  },
  methods : {
    haveAccess(accessType) {
      if (this.currentUser.applicationsAccess) {
        if (typeof this.currentUser.applicationsAccess === 'object') {
          return Object.values(this.currentUser.applicationsAccess).includes(accessType);
        }
        return this.currentUser.applicationsAccess.includes(accessType);
      }
      return false;
    },
    async getData(){
      this.downloadDicoLink = ApiService.getMediaApi().getDico();
      await this.load();
    },
    getReadableStatus(status) {
      if (status === 'completed') {
        return 'Complet';
      }

      if (status === 'failed') {
        return 'En échec';
      }

      return 'En cours';
    },
    getFavoriteIcon(item) {
      if (item.favorite === true) {
        return {
          class: 'fas fa-star',
          color: '#006AA2',
        }
      }

      return {
        class : 'far fa-star',
        color : ''
      };
    },
    getReadableDate(date) {
      return (new Date(date)).toLocaleDateString("fr");
    },
    async favorite(item) {
      await ApiService.getExportApi().favorite(item.id).then(() => {
        this.load();
      });
    },
    remove(item) {
      this.$store.dispatch('setExportUpdated', {
        mode: 'delete',
        item: item,
        action: 'Supprimer',
        cancel: true,
      });

      this.$root.$emit('bv::show::modal', 'form-export');
    },
    see(item) {
      this.$store.dispatch('setExportUpdated',{
        mode: 'see',
        item: item,
        action: 'Fermer',
        cancel: false,
      });

      this.$root.$emit('bv::show::modal', 'form-export');
    },
    create() {
      this.$store.dispatch('setExportUpdated',{
        mode: 'create',
        action: 'Créer',
        cancel: true,
      });

      this.$root.$emit('bv::show::modal', 'form-export');
    },
    showNotice() {
      this.$root.$emit('bv::show::modal', 'notice-modal');
    },
    duplicate(item) {
      this.$store.dispatch('setExportUpdated', {
        mode: 'duplicate',
        item: item,
        action: 'Dupliquer',
        cancel: true,
      });

      this.$root.$emit('bv::show::modal', 'form-export');
    },
    async download(item) {
      this.isLoading = true;
     await ApiService.getExportRetrievalApi().get(item.id, item.slug).then(() => {
       this.isLoading = false;
     }).catch(() => {});
    },
    async load() {
      this.isLoading = true;
      this.isLoadingAdminExports = true;
      await ApiService.getExportApi().list().then((data) => {
        this.exports = data.data;
        this.isLoading = false;
        if ((this.exports.filter((item) => {return item.status === 'processing'})).length > 0) {
          this.seeInfos = true;
        } else {
          this.seeInfos = false;
        }

        this.$forceUpdate();
      });

      await ApiService.getExportApi().listAdminExports().then((data) => {
        this.adminExports = data.data;
        this.isLoadingAdminExports = false;
        if ((this.adminExports.filter((item) => {return item.status === 'processing'})).length > 0) {
          this.seeInfosForAdminExports = true;
        } else {
          this.seeInfosForAdminExports = false;
        }

        this.$forceUpdate();
      });

    },
    /*checkStatut() {
      console.log('Interval reloading ...');
      window.setInterval(function () {
        if (this.exports === null || this.exports === undefined || this.exports.length === 0) {
          return;
        }

        console.log(this.exports.filter((item) => {
          return item.status === 'processing'
        }))

        while (this.exports.filter((item) => {
          return item.status === 'processing'
        }).length > 0) {
          console.log('reloading ...');
          this.load();
          this.interval++;
          console.log(this.interval);
        }
      }, 3000)
    }*/
  },
  watch : {
    getExportUpdated() {
      if (this.getExportUpdated !== '' && this.getExportUpdated.mode === 'reload') {
        this.isLoading = true;
        this.getData().then(() => this.isLoading = false)
      }
    },
  },
};
</script>
